<mat-toolbar>
  <ng-container *ngFor="let item of items; trackBy: trackByActionId">
    <aca-toolbar-action [actionRef]="item"></aca-toolbar-action>
  </ng-container>
</mat-toolbar>
